export const en = {
  common: {
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    logout: "Logout",
    enterEmail: "Enter your email address",
    enterPassword: "Enter your password",
    loginCredentials: "Please enter your credentials below to continue",
    invalidEmail: "Invalid email address",
    dontHaveAccount: "Don't have an account?",
    signUp: "Sign up",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign in",
    name: "Name",
    enterName: "Enter your name",
    confirmPassword: "Confirm Password",
    enterConfirmPassword: "Confirm your password",
    passwordsDoNotMatch: "Passwords do not match",
    registerSuccess: "Registration successful! Please login.",
  },
  sidebar: {
    analyzeDocument: "Analyze Document",
    directory: "Directory",
    users: "Users",
    settings: "Settings",
    prompts: "Prompts",
  },
  dashboard: {
    title: "Dashboard",
    analyzeDocument: "Analyze Document",
    metadata: "Metadata",
  },
  directory: {
    title: "Directory",
    listTitle: "Directory",
  },
  settings: {
    title: "Settings",
  },
  users: {
    title: "Users",
    listTitle: "Users",
  },
  prompts: {
    title: "Prompts",
    listTitle: "Prompts",
    createPrompt: "Create Prompt",
    filters: "Filters",
    clearFilters: "Clear Filters",
    filterCategory: "Category",
    filterSection: "Section",
    filterStatus: "Status",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    editPrompt: "Edit Prompt",
    editButton: "Edit",
    createButton: "Create",
    type: "Type",
    prompt: "Prompt",
    status: "Status"
  },
  language: {
    english: "English",
    spanish: "Spanish",
  },
  buttons: {
    export: "Export",
    aiAnalyze: "AI Analyze",
    addDocument: "Please add a document to analyze with Alt-Ai.",
    importDocument: "Import document",
    edit: "Edit",
    save: "Save",
    saveDocument: "Save document",
    refresh: "Refresh",
    download: "Download",
    enable: "Enable",
    disable: "Disable",
    activate: "Activate",
    activated: "Activated",
    show: "Show",
    delete: "Delete",
  },
  tables: {
    // Common table headers
    id: "Id",
    name: "Name",
    email: "Email",
    actions: "Actions",
    status: "Status",

    // Users table
    role: "Role",

    // Directory table
    date: "Date",
    category: "Category",

    // Prompts table
    type: "Type",
    prompts: "Prompts",
    no: "No.",
    section: "Section",
  },
  documentDetails: {
    fileDetails: "File Details",
    category: "Category",
    introduction: "Introduction",
    summary: "Summary",
    metadata: "Metadata",
    documentForCustomer: "Document for Customer",
    documentOf: "Document of",
    documentDate: "Document Date",
    documentReference: "Document Reference",
    filename: "Filename",

    // Analysis section
    analysis: "Analysis",
    signingTheContract: "Signing The Contract",
    validity: "Validity",
    extension: "Extension",
    renewal: "Renewal",
    annualAdjustment: "Annual Adjustment",
    subcontracting: "Subcontracting",
    subscriptionOfTheContract: "Subscription Of The Contract",
    reAdjustability: "Re-Adjustability",
    price: "Price",
    intellectualProperty: "Intellectual Property",
    deadlines: "Deadlines",

    // Comments section
    comments: "Comments",
    budgetAvailable: "Budget Available",
    guaranteeOfSeriousnessOffer: "Guarantee of Seriousness Offer",
    guaranteeOfFaithfulCompliance: "Guarantee of Faithful Compliance",
    fines: "Fines",
    earlyTermination: "Early Termination",
    pay: "Pay",
    estimatedContractAmount: "Estimated Contract Amount",
    guarantees: "Guarantees",
    offerValidity: "Offer Validity",
    scope: "Scope",
    evaluationCriteria: "Evaluation Criteria",
    terminationOfContract: "Termination of Contract",
    confidentiality: "Confidentiality",
    paymentTerm: "Payment Term",
    budgetModification: "Budget Modification",
    presentationOfWarranty: "Presentation of Warranty",
    extensionOfTheContractTerm: "Extension of the Contract Term",
    outsourcing: "Outsourcing",
    methodOfPayment: "Method of Payment",
    informationSecurity: "Information Security",
    ownershipOfInformation: "Ownership of Information",

    // Technical Comments section
    technicalComments: "Technical Comments",
    applicableStandards: "Applicable Standards",
    requiredResources: "Required Resources",
    trainings: "Trainings",
    averageMonthlyConsumption: "Average Monthly Consumption",
    emergencyService: "Emergency Service",
    correctiveMaintenance: "Corrective Maintenance",
    technicalRequirements: "Technical Requirements",
    trainingPlan: "Training Plan",
    maintenance: "Maintenance",
    executionDeadlines: "Execution Deadlines",
    staffRequired: "Staff Required",

    // Messages
    documentSavedSuccessfully: "Document Saved Successfully",
  },
  sections: {
    general: "General",
    analysis: "Analysis",
    comments: "Comments",
    technicalComments: "Technical Comments"
  },
  messages: {
    refreshing: "Refreshing...",
    loading: "Loading..."
  },
};
